import React from 'react';
import 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { CheckIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Input from '@teetsh/app/src/components/Form/Input2';

interface Props {
  value?: string;
  className?: string;
}

export function EditableTitle(props: Props) {
  const { value, className } = props;
  const [isEditing, setIsEditing] = React.useState(false);
  const [newName, setNewName] = React.useState(value || '');
  if (isEditing) {
    return (
      <div tw="flex items-center gap-x-2 min-w-0 py-1">
        <div>
          <Input
            fill
            tw="text-2xl font-bold min-w-[30rem]"
            className={className}
            value={newName}
            onChange={e => setNewName(e?.target?.value || '')}
            autoFocus
          />
        </div>
        <div>
          <Button
            icon={CheckIcon}
            iconSize="xl"
            onClick={() => {
              // Because we are in an iframe, we need to use the parent window to keep the whole context updated,
              // otherwise the iframe will be reloaded after each change made from the sidebar, and the new title will be lost
              const params = new URLSearchParams(window.parent.location.search);
              params.set('title', newName);
              // The use of history.replaceState prevents the iframe and the main page from reloading
              window.parent.history.replaceState(
                null,
                '',
                `?${params.toString()}`,
              );
              setIsEditing(false);
            }}
            minimal
          />
          <Button
            icon={XMarkIcon}
            iconSize="xl"
            onClick={() => {
              setNewName(value || '');
              setIsEditing(false);
            }}
            minimal
          />
        </div>
      </div>
    );
  }
  return (
    <div tw="flex items-center gap-x-2 min-w-0">
      <h1 className={className} id="programmation-print-title">
        {newName || ''}
      </h1>
      <Button
        tw="print:hidden"
        icon={PencilIcon}
        iconSize="xl"
        onClick={() => setIsEditing(true)}
        small
        minimal
      />
    </div>
  );
}
